/* @flow */

import { render, h } from 'preact';
import adicionarContatos from '../usuario/adicionar-contatos';
import modalVisualizacao from '../utils/modal-visualizacao';
import api from '../utils/api';

const mostrarDetalhes = async (pedidosId: number) => {
    const [
        { data: pedido },
        { data },
        { default: Detalhes },
    ] = await Promise.all([
        api.getPedidoPorId(pedidosId),
        api.getProdutosPorPedidosId(pedidosId),
        import('./components/Detalhes'),
    ]);

    pedido.produtos = data;
    if (pedido.usuario) {
        await adicionarContatos([pedido.usuario]);
    }

    let titulo = `Detalhes do pedido #${pedidosId}`;
    if (pedido.origem) {
        titulo = `${titulo} de origem: ${pedido.origem}`;
    }

    modalVisualizacao({
        titulo,
        texto: '',
    });

    const container = document.getElementById('modal-padrao-body');
    if (container) {
        render(h(Detalhes, { pedido }), container);
    }
};

export default mostrarDetalhes;
